<template>
  <div class="interaction">
    <!-- 互动交流 -->
    <!-- 内容区 -->
    <div class="content inner">
      <div class="childnav">
        <div class="desc">
          <img src="/statics/image/index/icon.png" alt />
          <span>{{cateact.title}}</span>
        </div>
        <el-tabs
          :tab-position="tabPosition"
          v-model="activeName"
          @tab-click="handleClick"
          v-if="cateact && cateact.s_cates"
        >
          <el-tab-pane
            v-for="(item,index) in cateact.s_cates"
            :key="index"
            :name="item.id.toString()"
          >
            <a
              href="javascript:scroll(0,0)"
              slot="label"
              v-if="item.link_flag!=1"
              :style="!item.display?'display: none;':''"
            >{{item.title?item.title:''}}</a>
            <a
              :href="item.url"
              slot="label"
              v-if="item.link_flag==1"
              :style="!item.display?'display: none;':''"
            >{{item.title?item.title:''}}</a>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="inter-right">
        <!-- 面包屑导航 -->
        <!--<div class="mbnav">
           <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">
            <img class="homeIcon" src="/statics/image/index/home.png" alt />
            首页
          </el-breadcrumb-item>
          <el-breadcrumb-item>互动交流</el-breadcrumb-item>
          </el-breadcrumb>
        </div>-->
        <!-- 答复列表 -->
        <div class="dafuList" v-if="parseInt(activeName)==5561">
          <!-- 主任信箱 -->
          <div class="zrEmail">
            <div class="pic" @click="toLetter">
              <img class="homeIcon" src="/statics/image/index/xinIcon.png" alt />
            </div>
            <div class="zr_con">
              <h3>主任信箱</h3>
              <p>该栏目我区反映信访问题的渠道之一，也是我区进一步密切与人民群众联系的桥梁和纽带。 受理举报、咨询、批评建议、申诉、控告及其他要求解决个人问题的信访事项。</p>
            </div>
          </div>
          <!-- 统计 -->
          <div class="tong">
            <div class="box">
              <div>
                <img class="homeIcon" src="/statics/image/index/wen.png" alt />
                <span>留言：</span>
                <span class="liunum">{{msgset.msg_num}}</span>
              </div>
              <div>
                <img class="homeIcon" src="/statics/image/index/da.png" alt />
                <span>回复：</span>
                <span class="huinum">{{msgset.reply_num}}</span>
              </div>
            </div>
          </div>
          <div class="hudongList">
            <div class="hudongItem" v-for="(item,index) in msgList.list" :key="index">
              <div class="wen">
                <img class="homeIcon" src="/statics/image/index/wen.png" alt />
                <span>{{item.title}}</span>
              </div>
              <div class="wencon">
                <div class="top">
                  <span>姓名：{{item.user_name}}</span>
                  <span>日期：{{item.created_at}}</span>
                </div>
                <p>{{item.content}}</p>
              </div>
              <div class="da" v-if="item.reply.content">
                <div class="top">
                  <img class="homeIcon" src="/statics/image/index/da.png" alt />
                  <span>【官方回答】</span>
                </div>
                <div>答复日期：{{item.reply.reply_at}}</div>
              </div>
              <div class="dacon" v-if="item.reply.content">
                <p>{{item.reply.content}}</p>
              </div>
            </div>
          </div>
          <!-- 分页 -->
          <div class="fenye clearfix">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pages.size"
              layout="prev, pager, next, jumper"
              :total="newsTotal"
              prev-text="上一页"
              next-text="下一页"
            ></el-pagination>
          </div>
        </div>
        <!-- 受理统计 -->
        <div class="slTong" v-if="parseInt(activeName)==5562">
          <div class="gg_list" v-if="article&&article.articlelist&&article.articlelist.length!=0">
            <div
              class="gg_item"
              v-for="(item,index) in article.articlelist"
              :key="index"
              @click="toInfo(activeName,item,item.article_id,item.link_flag)"
            >
              <div class="gg">
                <span>[公告] {{item.article_title}}</span>
              </div>
              <div class="time">
                <span>{{item.publish_at}}</span>
                <img src="/statics/image/index/gg_jiantou.png" alt />
              </div>
            </div>
          </div>
          <!-- 分页 -->
          <div class="fenye clearfix" v-if="article.articlelist.length!=0">
            <el-pagination
              @current-change="handleCurrentChangelist"
              :current-page.sync="currentPagelist"
              :page-size="pageslist.size"
              layout="prev, pager, next, jumper"
              :total="newsTotallist"
              prev-text="上一页"
              next-text="下一页"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      article: {articlelist:[]},
      tabPosition: "left", //导航对齐方式
      activeName: null,
      cateact: { title: "" },
      currentPage: 1, //当前页数
      currentPagelist: 1,
      pages: {
        page: 1,
        size: 10
      },
      pageslist: {
        page: 1,
        size: 10
      },
      newsTotal: 0, //总条数
      newsTotallist: 0, //总条数
      msgList: {},
      nowindex: "",
      msgset: {
        msg_num: "", //留言数
        reply_num: "" //回复数
      } //统计接口
    };
  },
  created() {
    this.nowindex = this.$route.query.index;
    this.getMsg();
    this.getNav();
  },
  methods: {
    // 导航选中触发
    handleClick(tab, event) {
    //   console.log("handleClick", tab, event);
      var is_child = 0;
      var link_flag = 0;
      var sanIndex = 0;
      for (var i in this.cateact.s_cates) {
        if (this.cateact.s_cates[i].id == tab.name) {
          is_child = this.cateact.s_cates[i].is_child;
          sanIndex = i;
          link_flag = this.cateact.s_cates[i].link_flag;
        }
      }
      if (link_flag != 1) {
        if (is_child == 1) {
          this.$router.push({
            path: "/xqNews_sanji",
            query: {
              id: 5562,
              index: this.nowindex,
              sanIndex: sanIndex,
              sanId: tab.name
            }
          });
        } else {
          if (tab.name != 5561) {
            this.getArticlelist();
          }
        }

        this.activeName = tab.name;
        // this.currentPage = 1; //当前页数
        // this.currentPagelist = 1; //当前页数
        // this.pageslist.page = 1;
        // this.pages.page = 1;
      }
    },
    getNav() {
      var that = this;
      that.$api.index.catelist({}).then(function(res) {
        if (res.code == 200) {
          for (var i in res.result.all_cate) {
            if (res.result.all_cate[i].id == 5473) {
              that.cateact = res.result.all_cate[i];
            }
          }
          for (var s in that.cateact.s_cates) {
            if (that.cateact.s_cates[s].display != 0) {
              that.activeName = that.cateact.s_cates[s].id.toString();
              if (that.cateact.s_cates[s].is_child != 1) {
                if (that.activeName != 5561) {
                  that.getArticlelist();
                }
              } else {
                if (that.activeName != 5561) {
                  var sanId = that.cateact.s_cates[s].s_cates[0].id.toString();
                  that.getArticlelist(sanId);
                }
              }
              break;
            }
          }
        }
      });
    },
    // 点击跳转到新区要闻详情
    toInfo(cate_id, item, id, flex) {
      if (flex == 0) {
        // console.log("跳", this.nowindex);
        this.$router.push({
          path: "/xqNews_detail",
          query: {
            cate_id,
            id: id,
            index: this.nowindex
            // erId: this.activeName
          }
        });
      } else {
        window.open(item.url);
      }
    },
    // 文章列表
    getArticlelist(sanId) {
      var that = this;
      // console.log(that.activeName,typeof that.activeName);
      // console.log('activeName:',that.activeName)
      var ps = {
        // cate_id: that.activeName * 1,
        page: that.pageslist.page,
        size: that.pageslist.size
      };
      if (sanId && sanId != "") {
        ps.cate_id = sanId;
      } else {
        ps.cate_id = that.activeName * 1;
      }
      if (that.topvalue && that.topvalue != "") {
        ps.keyword = that.topvalue;
      } else {
        ps.keyword = "";
      }
      that.$api.index.articlelist(ps).then(function(res) {
        if (res.code == 200) {
          that.article = res.result;
          for (var i in that.article.articlelist) {
            that.article.articlelist[
              i
            ].article_title = that.article.articlelist[
              i
            ].article_title.replaceAll("<br/>", "");
          }
          if (that.article.articlelist.length == 0) {
            that.$message({
              message: "搜索结果为空！",
              type: "warning"
            });
          }
          that.newsTotallist = res.result.total * 1;
        }
      });
    },
    getMsg() {
      var that = this;
      var ps = {
        page: that.pages.page,
        size: that.pages.size
      };
      that.$api.index.msgset({}).then(function(res) {
        if (res.code == 200) {
          that.msgset = res.result;
        }
      });
      that.$api.index.msg(ps).then(function(res) {
        if (res.code == 200) {
          that.msgList = res.result;
          that.newsTotal = res.result.total;
        }
      });
    },
    // 页数改变时触发
    handleCurrentChangelist(val) {
      // console.log(val);
      this.pageslist.page = val;
      this.getArticlelist();
      $("html,body").animate({ scrollTop: 0 }, "slow"); //顶部
    },
    // 页数改变时触发
    handleCurrentChange(val) {
      this.pages.page = val;
      this.getMsg();
      $("html,body").animate({ scrollTop: 0 }, "slow"); //顶部
    },
    // 点击写信
    toLetter() {
      this.$router.push({
        path: "/interaction_letter",
        query: {
          index: this.nowindex
        }
      });
    }
  },
  activated: function() {
    $("html,body").animate({ scrollTop: 0 }, "slow"); //顶部
  },
  watch: {
    $route(to, from) {
      this.nowindex = this.$route.query.index;
      this.getMsg();
    }
  }
};
</script>

<style>
</style>